import { i18nNsFactory } from '@atlas-frontend/i18n';
import { z } from 'zod/v3';
import { AlgorithmJoinValidFormDataSchema } from './AlgorithmJoinValidFormDataSchema';
import translations from './AlgorithmJoinsValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-joins-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmJoinsValidFormDataSchema = z.object({
  joins: z.array(AlgorithmJoinValidFormDataSchema).refine(
    (joins) => joins.length !== 1,
    () => ({
      path: ['root'],
      message: t('validation.minimum-2-joins-required'),
    }),
  ),
});
